// extracted by mini-css-extract-plugin
export default {"pd":"Mcp_pd__kDjo1"};